export default function setupClarity() {
  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  const collect = document.createElement("script");
  collect.async = 1;
  collect.src = "https://www.clarity.ms/tag/" + "eg87y6q50o";

  document.head.prepend(collect);
}
